import React from 'react';
import Navigation from '../components/landing/Navigation';
import Hero from '../components/landing/Hero';
import InstrumentGrid from '../components/landing/InstrumentGrid';
import Guitar from '../components/landing/Guitar';
import MusicPlayer from '../components/landing/MusicPlayer';
import Features from '../components/landing/Features';
import Testimonials from '../components/landing/Testimonials';
import CallToAction from '../components/landing/CallToAction';
import Footer from '../components/Footer';

const Landing: React.FC = () => {
  return (
    <div className="min-h-screen bg-gradient-to-b from-black to-indigo-950 text-white overflow-hidden">
      {/* Navigation */}
      <Navigation />

      {/* Hero Section with Instrument Grid */}
      <div className="relative pt-16 pb-24 px-6 overflow-hidden">
        <Hero />
        <div className="max-w-7xl mx-auto relative z-10">
          <div className="flex flex-col items-center justify-center">
            <h2 className="text-2xl md:text-3xl font-bold mb-8 text-center">
              <span className="bg-gradient-to-r from-yellow-400 to-yellow-200 bg-clip-text text-transparent">
                Explore Musical Instruments in Spanish
              </span>
            </h2>
            <InstrumentGrid />
          </div>
        </div>
      </div>

      {/* Guitar Interactive Section */}
      <Guitar />

      {/* Music Player Preview */}
      <MusicPlayer />

      {/* Features Section */}
      <Features />

      {/* Testimonials */}
      <Testimonials />

      {/* CTA Section */}
      <CallToAction />

      {/* Footer */}
      <Footer />

      {/* Custom Styles */}
      <style jsx>{`
        @keyframes blob {
          0% {
            transform: translate(0px, 0px) scale(1);
          }
          33% {
            transform: translate(30px, -50px) scale(1.1);
          }
          66% {
            transform: translate(-20px, 20px) scale(0.9);
          }
          100% {
            transform: translate(0px, 0px) scale(1);
          }
        }
        
        .animate-blob {
          animation: blob 7s infinite;
        }
        
        .animation-delay-2000 {
          animation-delay: 2s;
        }
        
        .animation-delay-4000 {
          animation-delay: 4s;
        }
      `}</style>
    </div>
  );
};

export default Landing;